import React from 'react';
import { withRouter, Redirect } from 'react-router-dom';
import { Grid, Container} from "@material-ui/core";
import { AuthContext } from "../../contexts/authContext";

import PltwNavBar from '../../common/pltwNavBar';
import PdfCard from "../../components/pdfCard";

import {additionalInfo} from "../loginPage/constants";
import { data } from "../../common/data";
import { zeroWasteLogo } from "../../common/images";

import './homePage-styles.scss';


const HomePage = ({ match: { params: { category } }}) => {

  let title;
  title = category === '1' ? 'Grades K - 2'
    : category === '2' ? 'Grades 3 - 5'
      : category === '3' ? 'Grades 6 - 8'
        : category === '4' ? 'Grades 9 - 12'
          : 'No PDFs available';

  const filteredData = data.filter(data => data.category === category);

  return (
      <AuthContext.Consumer>{ (context)=>{
        const { isLoggedIn } = context
        return(
            isLoggedIn ?
                <div>
                  <Grid container spacing={6} alignItems="center">
                    <Grid item xs={12} style={{ paddingBottom: '0px' }}>
                      <PltwNavBar />
                    </Grid>
                    <Grid item xs={12} style={{ paddingTop: '0px' }}>
                      <div className='zeroWaste-container'>
                        <img src={zeroWasteLogo} className='zeroWaste-logo' alt='zero waste' />
                      </div>
                    </Grid>
                    <Grid item xs={12}>
                      <div className={`title${category}`}>
                        <h1>{title}</h1>
                      </div>
                    </Grid>

                    <Container>
                      <div  className='mainContainer'>
                        {
                          filteredData.map(item => (
                              <div className='card-list' key={item.id}>
                                <PdfCard {...item} />
                              </div>
                          ))
                        }
                      </div>
                    </Container>

                    <Grid item xs={12}>
                      <div className='info'>
                        <p>{additionalInfo}</p>
                      </div>
                    </Grid>

                  </Grid>

                </div>
                :<div><Redirect to='/' /></div>
        )
      }}
      </AuthContext.Consumer>
  );
};

export default withRouter(HomePage);
